import React, { useState, useEffect } from 'react';
import ShopMap from '../../common/ShopMap/ShopMap';
import './OneSearch.css';

/** The verified-middlemen map, as its own destination. */
function Middlemen() {
    const [shops, setShops] = useState(null);

    useEffect(() => {
        fetch('/api/shops')
            .then(r => (r.ok ? r.json() : { shops: [] }))
            .then(d => setShops(d.shops || []))
            .catch(() => setShops([]));
    }, []);

    return (
        <div className="onesearch">
            <header className="page-section-head">
                <h1>Middlemen <span className="page-section-current">Verified shops</span></h1>
            </header>
            <p className="os-hint">
                Card shops that hold and check both sides of a trade before forwarding.
                Search the list or explore the map; open a store page for ratings and fees.
            </p>
            {shops === null ? (
                <p className="os-hint">Loading middlemen&hellip;</p>
            ) : shops.length === 0 ? (
                <div className="requests-placeholder">No verified middlemen yet.</div>
            ) : (
                <ShopMap withSearch shops={shops} height={480} />
            )}
        </div>
    );
}

export default Middlemen;
